module.exports = __webpack_public_path__ + "fb26a841146b97d0b943e82a72474adf.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-768.webp.png
// module id = 231
// module chunks = 0